import { useState } from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, CircularProgress, Typography, Autocomplete, TextField } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import PageService from '../../services/PageService'

const CreateFolderModal = ({
  blueprintFolders = [],
  dropdownElInfo,
  createFolderOpen,
  setCreateFolderOpen,
  setTestCasesToggler
}) => {
  const [selectedFolder, setSelectedFolder] = useState(null)
  const [folderError, setFolderError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleCloseDialog = () => {
    setCreateFolderOpen(false)
    setSelectedFolder(null)
    setFolderError('')
  }

  const handleCreateFolder = async () => {
    if (!selectedFolder) {
      setFolderError('Folder is required.')
      return
    } else {
      setFolderError('')
    }

    const cycleId = dropdownElInfo?.cycleId || dropdownElInfo?.id
    if (!cycleId) {
      setFolderError('Cycle is not selected.')
      return
    }

    try {
      setLoading(true)
      await PageService.addTestsToCycle(cycleId, {
        pageIds: [selectedFolder.id],
      })
      setTestCasesToggler(prev => !prev)
      setCreateFolderOpen(false)
      setSelectedFolder(null)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog open={createFolderOpen} onClose={handleCloseDialog}>
      <Box className="createTestCaseFolderModal">
        <DialogTitle className="createTestCaseFolderModalTitle">
          Create Folder
        </DialogTitle>
        <DialogContent className="createTestCaseFolderModalContent">
          <Typography variant='body1' mb={2}>
            Select a folder from Page Blueprints to include in the cycle
          </Typography>
          <Autocomplete
            fullWidth
            options={blueprintFolders}
            getOptionLabel={(option) => option?.name || ''}
            value={selectedFolder}
            onChange={(_, value) => {
              setSelectedFolder(value)
              if (folderError) setFolderError('')
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Folder*"
                error={!!folderError}
                helperText={folderError + ' '}
              />
            )}
          />
        </DialogContent>
        <DialogActions className="createTestCaseFolderModalActions">
          <Button className="createTestCaseFolderModalButton" onClick={handleCloseDialog} color="secondary" variant="outlined">
            CANCEL
          </Button>
          {loading ? (
            <LoadingButton
              loading
              className="createTestCaseFolderModalButton"
              variant="contained"
              loadingIndicator={<CircularProgress color="white" size={16} />}
            />
          ) : (
            <Button className="createTestCaseFolderModalButton" onClick={handleCreateFolder} color="secondary" variant="contained" autoFocus>
              SAVE
            </Button>
          )}
        </DialogActions>
      </Box>
    </Dialog>
  )
}

export default CreateFolderModal
